/*
 * Copyright (c) 2021.
 * Md Naimul Hasan
 * naim886@gmail.com
 * 01719123886
 * www.naimbd.com
 */
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import {BrowserRouter, Route} from "react-router-dom";
import '../node_modules/bootstrap/dist/css/bootstrap.min.css'
import './Assets/css/styles_admin.css'
import './Assets/css/style.css'
import './Assets/js/scripts'
import Home from './Components/Pages/Home'
import Nav from "./Components/Include/Nav";
import SideBar from "./Components/Include/SideBar";
import Footer from "./Components/Include/Footer";
import FooterLink from "./Components/Pages/FooterLink/FooterLink";
import AppointmentList from "./Components/Pages/Appointment/AppointmentList"
import CreateTruck from "./Components/Pages/Truck/CreateTruck";
import Truck from "./Components/Pages/Truck/Truck";
import Login from "./Components/Pages/Login";
import {useEffect, useState} from "react";
import Auth from "./Auth";
import AppointmentDetails from "./Components/Pages/Appointment/AppointmentDetails";
import Schedule from "./Components/Pages/Schedule/Schedule";
import CustomerList from "./Components/Pages/Customer/CustomerList";
import Report from "./Components/Pages/Report/Report";

function App() {
    const [url, setUrl]= useState('')
    useEffect(()=>{
        setUrl(window.location.pathname)
        console.log(url)
    }, [])
    return (
        <>
            {url =='/login'?
                <BrowserRouter>
                    <Route  path={'/login'} component={Login}/>
                </BrowserRouter>:
                <BrowserRouter>
                    <Nav/>
                    <div id="layoutSidenav">
                        <SideBar/>
                        <div id="layoutSidenav_content">
                            <Auth exact path={'/'} component={Home}/>
                            <Auth exact path={'/truck'} component={Truck}/>
                            <Auth exact path={'/truck/create'} component={CreateTruck}/>
                            <Auth exact path={'/footer-link'} component={FooterLink}/>
                            <Auth exact path={'/appointment'} component={AppointmentList}/>
                            <Auth exact path={'/appointment/details/:id'} component={AppointmentDetails}/>
                            <Auth exact path={'/schedule'} component={Schedule}/>
                            <Auth exact path={'/customer-list'} component={CustomerList}/>
                            <Auth exact path={'/report'} component={Report}/>
                            <Footer/>
                        </div>
                    </div>
                </BrowserRouter>
            }


        </>

    );
}

export default App;
